module.exports = __webpack_public_path__ + "static/media/bg-5.c16c97e0.png";